module.exports = __webpack_public_path__ + "img/bms-softwares-logo.c5153407.png";